/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import { filtrationcontext } from "../../../../context/Filtercontext";
import Searchbar from "../../../Helpers/Searchbar/Searchbar";
import trans from "../../../../utils";
import { InputSelect } from "../../../Helpers/Input/RefactoredInput";

export default function RolesHead({ setFilter, setCurrentPage }) {
	//const [activeItem, setActiveItem] = useState("All vehicles");
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};
	const statusOptions = [
		{ label: trans("Active"), value: true },
		{ label: trans("Inactive"), value: false },
	];
	const accessType = [
		{ label: trans("Supervisor"), value: "SUPERVISOR" },
		{ label: trans("Field Staff"), value: "FIELD_STAFF" },
		{ label: trans("Customer"), value: "CUSTOMER" },
	];
	const Hierarchylevel = [
		{ label: trans("Manager"), value: "manager" },
		{ label: trans("Device Readonly"), value: "devicereadonly" },
		{ label: trans("Readonly"), value: "readonly" },
	];
	return (
		<>
			<div className="bg-white p-16 d-flex align-items-baseline gap-3">
				<Searchbar
					style="search search-dark input-group"
					path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
					placeholder={trans("Search")}
					value={query}
					onChange={handleSearch}
				/>
				<InputSelect
					placeholder={trans("Access Type")}
					options={accessType}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({ ...prev, userType: e }));
						setCurrentPage(1);
					}}
				/>
				{/* <InputSelect
					placeholder={trans("Hierarchy Level")}
					options={Hierarchylevel}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({ ...prev, tc_role: e }));
						setCurrentPage(1);
					}}
				/> */}

				<InputSelect
					placeholder={trans("Status")}
					options={statusOptions}
					formstyle="flex-grow-1 text-capitalize"
					onChange={(e) => {
						setFilter((prev) => ({ ...prev, status: e }));
						setCurrentPage(1);
					}}
				/>
			</div>
		</>
	);
}
